import { Fragment, type ComponentType } from 'react'
import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Building2, Users, CreditCard, Globe } from 'lucide-react'
import { navConfig, type NavCounts } from '../shell/navConfig'
import type { IconKey } from '../icons'
import type { Role } from '../../types'

/** IconKey → lucide-Icon (nur die in der Admin-Nav genutzten Keys). */
const navIcons: Partial<Record<IconKey, ComponentType<{ size?: number | string; className?: string }>>> = {
  dash: LayoutDashboard,
  brand: Building2,
  users: Users,
  card: CreditCard,
  domains: Globe,
}

/**
 * Rollenabhängige Konsolen-Navigation (`.side` aus console.css, lucide-Icons).
 * Struktur aus `navConfig` (reine Datenfunktion): je Gruppe ein `.nav-group`-Label
 * + `.nav-item`-NavLinks; aktive Route erhält zusätzlich die Klasse `active`.
 */
export function AdminSideNav({ role, counts }: { role: Role; counts?: NavCounts }) {
  const groups = navConfig(role, counts)
  return (
    <nav className="side" aria-label="Hauptnavigation">
      {groups.map((g) => (
        <Fragment key={g.grp}>
          <div className="nav-group">{g.grp}</div>
          {g.items.map((it) => {
            const Icon = navIcons[it.icon] ?? CreditCard
            return (
              <NavLink
                key={it.key}
                to={it.to}
                end
                className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
              >
                <span className="ico">
                  <Icon size={18} />
                </span>
                {it.label}
                {it.count != null && <span className="count">{it.count}</span>}
              </NavLink>
            )
          })}
        </Fragment>
      ))}
      <div className="nav-foot">BMC · vCard-Plattform</div>
    </nav>
  )
}
